export enum ProjectStatus {
  Prelaunch = 1,
  Launched = 2,
  Closed = 3,
  Archived = 4
}
